import asyncFork from "./asyncFork";

let obj = {
  init() {
    const geminiUser = process.env.REACT_APP_GEMINI_USER === 'true';
    return asyncFork.init({
      baseUrl: !geminiUser ? process.env.REACT_APP_API_BASE_URL: process.env.REACT_APP_CSR_API_BASE_URL,
      apiToken: ""
    });
  }
};

export default obj;